export var defaultProps = {
  header: [{
    title: 'Requests',
    showSortingFilter: true
  }, {
    title: 'LOB / SI',
    showQuickFilter: true,
    quickFilterTitle: 'Title Here'
  }, {
    title: 'Type / Subtype',
    showSortDESCOrder: true,
    showSortingFilter: true
  }, {
    title: 'Completion Date',
    showQuickFilter: true
  }],
  list: [[{
    heading: 'heading heading\n heading \nheading',
    subHeading: '12135',
    subHeadingAsLink: false,
    showIcon: false,
    showToolTipOnHeading: true,
    tooltipProps: {
      text: 'Lorem ipsum dolor sit \n Lorem ipsum dolor sit \n Lorem ipsum dolor sit'
    }
  }, {
    heading: 'heading2',
    subHeadingBold: '12135',
    showToolTipOnHeading: true,
    tooltipProps: {
      text: 'Lorem ipsum dolor sit'
    },
    subHeadingAsLink: false,
    showIcon: false
  }, {
    heading: 'heading3',
    subHeading: '12135',
    subHeadingAsLink: false,
    showIcon: false
  }, {
    showContextMenuIcon: true,
    showDropdown: true,
    tooltipProps: {
      text: 'Lorem ipsum dolor sit'
    },
    actionIcons: [{
      id: '101',
      iconName: 'CopyButtonIcon',
      onPress: {
        id: '1st icon'
      }
    }, {
      id: '102',
      iconName: 'CopyButtonIcon'
    }, {
      id: '103',
      iconName: 'CopyButtonIcon'
    }, {
      id: '104',
      iconName: 'CopyButtonIcon'
    }],
    dropdownMenuData: {
      dropdownList: [{
        heading: 'Refund',
        onPress: {
          id: 'refund'
        }
      }, {
        heading: 'Transfer'
      }, {
        heading: 'Email Receipt'
      }],
      parentType: 'icon',
      actionIconName: 'MoreIcon',
      variant: 'none',
      dropdownMenuStyles: {
        width: 138,
        height: 115
      }
    }
  }], [{
    heading: 'heading',
    subHeading: '12135 12135 12135 12135 12135',
    subHeadingAsLink: true,
    infoTagText: 'offer offer offer offer offer',
    infoTagType: 'new',
    showIcon: false,
    ctaText: 'button'
  }, {
    heading: 'heading',
    subHeading: '12135',
    subHeadingAsLink: false,
    infoTagText: 'offer',
    infoTagType: 'new',
    showIcon: false
  }, {
    heading: 'heading6',
    subHeading: '12135',
    subHeadingAsLink: false,
    infoTagText: 'offer',
    infoTagType: 'new',
    showIcon: false
  }, {
    heading: 'heading7',
    subHeading: '12135',
    subHeadingAsLink: false,
    infoTagText: 'offer',
    infoTagType: 'new',
    showIcon: false,
    contextMenuIconName: 'MoreIcon',
    showToolTipOnHeading: true,
    tooltipProps: {
      text: 'Lorem ipsum dolor sit',
      autoHide: true
    }
  }], [{
    heading: 'heading8',
    subHeading: '12135',
    subHeadingAsLink: false,
    infoTagText: 'offer',
    infoTagType: 'new',
    showIcon: false
  }, {
    heading: 'heading',
    subHeading: '12135',
    subHeadingAsLink: false,
    infoTagText: 'offer',
    infoTagType: 'new',
    showIcon: false
  }, {
    heading: 'heading',
    subHeading: '12135',
    subHeadingAsLink: false,
    infoTagText: 'offer',
    infoTagType: 'new',
    showIcon: false
  }, {
    heading: 'heading',
    subHeading: '12135',
    subHeadingAsLink: false,
    infoTagText: 'offer',
    infoTagType: 'new',
    showIcon: false
  }]],
  onUserAction: function onUserAction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    console.log('onUserAction', args);
  }
};